import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILens } from '../types/ILens';

export interface IGetLensesParams extends IGetItemsParams {
}

export interface IGetLensesResult extends IGetItemsResult {
  lenses?: ILens[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetLensesRequest extends Request<IGetLensesParams, IGetLensesResult> {
  constructor(params: IGetLensesParams) {
    super('getLenses', params);
  }
}
